import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { SubService } from 'src/app/services/sub.service';
import { deburr } from 'lodash'
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { BeControleFinancaMovimento } from 'src/app/models/BeControleFinancaMovimento';
import { BeControleFinancaXMovimento } from 'src/app/models/BeControleFinancaXMovimento';
import { DialogTextValueComponent } from 'src/app/components/dialog-text-value/dialog-text-value.component';
import { BespCopiarMovimento } from 'src/app/models/BespCopiarMovimento';
import { BespPagarListaMovimento } from 'src/app/models/BespPagarListaMovimento';
import { MatButton } from '@angular/material/button';
import { ConfirmService } from '@app/services/confirm.service';
import { DialogControleFinancaMovimentoData } from '@app/models/dialog-controle-financa-movimento-data';
import { DialogControleFinancaMovimentoComponent } from '@app/components/dialog-controle-financa-movimento/dialog-controle-financa-movimento.component';
import { BespCopiarListaMovimento } from '@app/models/BespCopiarListaMovimento';
import { BespCofxCopiarCartao } from '@app/models/BespCofxCopiarCartao';
import { DialogImagemComponent } from '@app/components/dialog-imagem/dialog-imagem.component';
import { DialogCsvConfigComponent, CsvConfig } from '@app/components/dialog-csv-config/dialog-csv-config.component';

@Component({
  selector: 'app-controle-financa-movimentos',
  templateUrl: './list-controle-financa-movimentos.component.html',
  styleUrls: ['./list-controle-financa-movimentos.component.css']
})
export class ListControleFinancaMovimentosComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) public paginator?: MatPaginator;
  @ViewChild(MatButton) public botaoOpcaoLinha?: MatButton;
  @Input() public controleFinancaXMovimento?: BeControleFinancaXMovimento;
  @Output() public isChanged: EventEmitter<void> = new EventEmitter<void>();
  @Output() public isDeleted: EventEmitter<void> = new EventEmitter<void>();
  @Output() public isCartao: EventEmitter<BeControleFinancaMovimento> = new EventEmitter<BeControleFinancaMovimento>();
  @Output() public countChanged: EventEmitter<number> = new EventEmitter<number>();

  public dataSrc = new MatTableDataSource<BeControleFinancaMovimento>();
  public dataCols: string[] = [];
  public subscription?: Subscription;
  public filterControl = new FormControl<string>("");
  public filterSubscription?: Subscription;
  public editandoLinha = false;
  public itensSelecionados: BeControleFinancaMovimento[] = [];
  public listaCartoes: BeControleFinancaXMovimento[] = [];

  public constructor(
    private httpClient: HttpClient,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
    private confirmService: ConfirmService
  ) {
    this.dataSrc = new MatTableDataSource();
  }

  public ngOnInit(): void {
    if (this.controleFinancaXMovimento!.idControleFinancaXMovimento) {
      this.subscription = this.httpClient.get<BeControleFinancaMovimento[]>(
        `/api/ControleFinancaMovimentos/ListarPorIdCofx/${this.controleFinancaXMovimento!.idControleFinancaXMovimento}`
      ).subscribe({
        next: (res) => {
          this.unsubscribe();
          this.onResult(res);
          this.emitCount();
          if (this.controleFinancaXMovimento?.noTipoMovimento === 'Saída') {
            this.buscarListaCartoes(this.controleFinancaXMovimento.idControleFinanca);
          }
          this.dataCols = this.controleFinancaXMovimento!.noTipoMovimento == 'Saída' ? ["blSelecionado", "noMovimentacao", "vlMovimentacao", "dtMovimentacao", "dtVencimento", "blGeradaCopia", "buttons"] :
            ["blSelecionado", "noMovimentacao", "vlMovimentacao", "dtMovimentacao", "blGeradaCopia", "buttons"]
        },
        error: (err) => {
          this.unsubscribe();
          this.snackBarService.exibirErro(`${err.error} - Erro ${err.status} - ${err.statusText}`);
        }
      });
    }
  }

  public buscarListaCartoes(idControleFinanca: number): void {
    if (this.subscription)
      return;

    this.subscription = this.httpClient.get<BeControleFinancaXMovimento[]>(
      `/api/ControleFinancas/ListarCartoes/${idControleFinanca}`
    ).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.listaCartoes = res;
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`${err.error} - Erro ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
    this.filterSubscription?.unsubscribe();
  }

  public onCreate() {
    if (this.paginator && this.paginator.pageIndex > 0) {
      this.paginator.firstPage();
    }

    this.dataSrc.data.unshift({
      idControleFinancaXMovimento: this.controleFinancaXMovimento!.idControleFinancaXMovimento,
      noMovimentacao: '',
      vlMovimentacao: 0,
      dtMovimentacao: new Date(),
      dtVencimento: new Date(),
      blPago: false,
      blGeradaCopia: false,
      blSelecionado: false,
      editing: true
    });
    this.editandoLinha = true;
    this.dataSrc._updateChangeSubscription();
    this.emitCount();

    setTimeout(() => {
      const input = document.querySelector(
        '.data-table tr:first-child input[matInput]'
      ) as HTMLInputElement;
      if (input) {
        input.focus();
      }
    });

  }

  public onEdit(controleFinanca: BeControleFinancaMovimento) {
    this.editandoLinha = true;
    controleFinanca.editing = true;
    controleFinanca.originalValues = { ...controleFinanca };
    setTimeout(() => {
      const input = document.querySelector(
        `#input-noMovimentacao-${controleFinanca.idControleFinancaMovimento}`
      ) as HTMLInputElement;
      if (input) {
        input.focus();
        input.select();
      }
    });
  }

  public onDelete(controleFinancaMovimento: BeControleFinancaMovimento) {
    this.confirmService.confirm('Deseja excluir esse registro?', 'Alerta', 'Excluir')
      .subscribe(res => {
        if (res) {
          this.sub.reset(this.httpClient.delete(`/api/ControleFinancaMovimentos/${controleFinancaMovimento.idControleFinancaMovimento}`),
            () => this.onDeleteConfirm(controleFinancaMovimento),
            () => this.snackBarService.exibirErro('Não foi possível excluir o registro!')
          );
        }
      });
  }

  public onSalvarLinha(controleFinancaMovimento: BeControleFinancaMovimento, isPaid: boolean = false) {
    this.unsubscribe();

    const data: BeControleFinancaMovimento = {
      idControleFinancaXMovimento: controleFinancaMovimento.idControleFinancaXMovimento,
      noMovimentacao: controleFinancaMovimento.noMovimentacao,
      vlMovimentacao: controleFinancaMovimento.vlMovimentacao,
      dtMovimentacao: controleFinancaMovimento.dtMovimentacao,
      dtVencimento: controleFinancaMovimento.dtVencimento,
      blPago: isPaid ? !controleFinancaMovimento.blPago : controleFinancaMovimento.blPago,
      blGeradaCopia: controleFinancaMovimento.blGeradaCopia,
      blSelecionado: controleFinancaMovimento.blSelecionado,
      idImagem: controleFinancaMovimento.idImagem,
    };

    if (controleFinancaMovimento.idControleFinancaMovimento) {
      data['idControleFinancaMovimento'] = controleFinancaMovimento.idControleFinancaMovimento;
      this.subscription = this.httpClient.put<BeControleFinancaMovimento>('/api/ControleFinancaMovimentos/', data).subscribe(this.getCallback(controleFinancaMovimento, false, isPaid));
    }
    else {
      this.subscription = this.httpClient.post<BeControleFinancaMovimento>('/api/ControleFinancaMovimentos/', data).subscribe(this.getCallback(controleFinancaMovimento, true, isPaid));
    }
  }

  public onCancelarLinha(controleFinancaMovimento: BeControleFinancaMovimento) {
    if (controleFinancaMovimento.originalValues && (
      controleFinancaMovimento.noMovimentacao !== controleFinancaMovimento.originalValues.noMovimentacao ||
      controleFinancaMovimento.vlMovimentacao !== controleFinancaMovimento.originalValues.vlMovimentacao ||
      controleFinancaMovimento.dtMovimentacao !== controleFinancaMovimento.originalValues.dtMovimentacao ||
      controleFinancaMovimento.dtVencimento !== controleFinancaMovimento.originalValues.dtVencimento
    )) {
      this.confirmService.confirm('Aceita descartar as alterações?', undefined, 'Descartar')
        .subscribe(result => {
          if (result)
            this.cancelarLinha(controleFinancaMovimento);
        });
    }
    else
      this.cancelarLinha(controleFinancaMovimento);
  }

  public onCopiarMovimento(controleFinancaMovimento: BeControleFinancaMovimento) {
    if (this.subscription || this.editandoLinha || controleFinancaMovimento.editing)
      return;
    this.dialog.open(DialogTextValueComponent, {
      data: {
        title: `${controleFinancaMovimento.blGeradaCopia ? 'Atencão:\nCopiar movimento novamente?' : 'Copiar movimento'}`,
        textName: 'noMovimentacao',
        textTitle: 'Descrição',
        textValue: controleFinancaMovimento.noMovimentacao,
        numberName: 'vlMovimentacao',
        numberTitle: 'Valor',
        numberValue: controleFinancaMovimento.vlMovimentacao,
        numberRequired: true,
        buttonText: 'Copiar',
        secondButtonText: 'Cancelar',
        idTabelaPai: 'idControleFinancaMovimento',
        idTabela: controleFinancaMovimento.idControleFinancaMovimento!
      }
    })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.sub.reset(this.httpClient.post<BespCopiarMovimento>(`/api/ControleFinancaMovimentos/CopiarMovimento`, {
            idCofm: result.idControleFinancaMovimento,
            noMovimentacao: result.noMovimentacao,
            vlMovimentacao: result.vlMovimentacao
          }),
            (res) => {
              this.unsubscribe();
              if (res.retorno) {
                controleFinancaMovimento.blGeradaCopia = true;
                this.snackBarService.exibirSucesso('Registro copiado!');
              }
              else
                this.snackBarService.exibirErro(res.retornoMensagem!);
            },
            () => this.snackBarService.exibirErro('Não foi possível copiar o registro!')
          );
        }
        else
          this.unsubscribe();
      })
  }

  public areAllSelected(): boolean {
    return this.dataSrc.data.length > 0 && this.itensSelecionados.length === this.dataSrc.data.length;
  }

  public toggleSelecionarTudo(): void {
    if (this.areAllSelected()) {
      this.dataSrc.data.forEach(item => item.blSelecionado = false);
      this.itensSelecionados = [];
    } else {
      this.dataSrc.data.forEach(item => {
        item.blSelecionado = true;
        if (!this.itensSelecionados.includes(item)) {
          this.itensSelecionados.push(item);
        }
      });
    }
    this.dataSrc._updateChangeSubscription();
  }

  public onChangeCheckbox(item: BeControleFinancaMovimento): void {
    if (item.blSelecionado) {
      if (!this.itensSelecionados.includes(item)) {
        this.itensSelecionados.push(item);
      }
    } else {
      this.itensSelecionados = this.itensSelecionados.filter(i => i !== item);
    }
  }

  public get valorTotalSelecionado(): number {
    return this.itensSelecionados.reduce((acc, item) => acc + (item.vlMovimentacao || 0), 0);
  }

  public onPagarListaMovimento(blPago: boolean = true): void {
    this.sub.reset(this.httpClient.post<BespPagarListaMovimento>(`/api/ControleFinancaMovimentos/PagarListaMovimento`, {
      listaIdCofm: this.itensSelecionados.map(item => item.idControleFinancaMovimento!).join(','), blPago
    }),
      (res) => {
        if (res.retorno) {
          this.itensSelecionados.forEach(item => {
            item.blPago = blPago;
          });
          this.snackBarService.exibirSucesso('Registros alterados!');
        }
        else
          this.snackBarService.exibirErro(res.retornoMensagem!);

        this.clearSelectedItems();
      },
      () => this.snackBarService.exibirErro('Não foi possível alterar os registros!')
    );
  }

  public onCopiarListaMovimento(): void {
    const dialogRef = this.dialog.open(DialogControleFinancaMovimentoComponent, {
      data: {
        title: 'Selecione os Movimentos para Copiar',
        idCofx: this.controleFinancaXMovimento?.idControleFinancaXMovimento,
        noTipoMovimento: this.controleFinancaXMovimento?.noTipoMovimento,
        controleFinancaMovimentos: this.itensSelecionados.map(item => ({
          idControleFinancaMovimento: item.idControleFinancaMovimento!,
          noMovimentacao: item.noMovimentacao!,
          vlMovimentacao: item.vlMovimentacao!,
          dtMovimentacao: item.dtMovimentacao!,
          dtVencimento: item.dtVencimento!,
          blPago: item.blPago!,
          blCopia: item.blGeradaCopia!,
          blSelecionado: true,
        })),
        buttonText: 'Copiar',
        cancelButtonText: 'Cancelar',
      } as DialogControleFinancaMovimentoData,
    });

    dialogRef.afterClosed().subscribe((result: BeControleFinancaMovimento[]) => {
      if (result) {
        const payload: BespCopiarListaMovimento = {
          listaCofm: result.map(item => ({
            idCofm: item.idControleFinancaMovimento!,
            noMovimentacao: item.noMovimentacao!,
            vlMovimentacao: item.vlMovimentacao!
          }))
        };

        this.unsubscribe();
        this.subscription = this.httpClient.post<BespCopiarListaMovimento>(
          `/api/ControleFinancaMovimentos/CopiarListaMovimento`,
          payload
        ).subscribe({
          next: (res) => {
            if (res.retorno) {
              this.itensSelecionados.forEach(item => {
                item.blGeradaCopia = true;
              });
              this.snackBarService.exibirSucesso('Registros copiados!');
            }
            else
              this.snackBarService.exibirErro(res.retornoMensagem!);

            this.clearSelectedItems();
            this.unsubscribe();
          },
          error: () => {
            this.snackBarService.exibirErro('Não foi possível copiar os registros!');
            this.unsubscribe();
          }
        });
      }
    });
  }

  public onDeleteListaMovimento(): void {
    this.confirmService.confirm('Deseja excluir os itens selecionados?', 'Alerta', 'Excluir').subscribe(result => {
      if (result) {
        this.sub.reset(this.httpClient.post<BespCopiarMovimento>(`/api/ControleFinancaMovimentos/ExcluirListaMovimento`, {
          listaIdCofm: this.itensSelecionados.map(item => item.idControleFinancaMovimento!).join(',')
        }),
          (res) => {
            if (res.retorno) {
              this.snackBarService.exibirSucesso('Itens excluídos com sucesso!');
              this.dataSrc.data = this.dataSrc.data.filter(item => !this.itensSelecionados.includes(item));
              this.clearSelectedItems();
            }
            else
              this.snackBarService.exibirErro(res.retornoMensagem!);
          },
          () => this.snackBarService.exibirErro('Não foi possível excluir os registros!')
        );
      }
      else
        this.unsubscribe();
    });
  }

  public onDeleteCartao(): void {
    this.confirmService.confirm('Deseja excluir esse registro?', 'Alerta', 'Excluir')
      .subscribe(result => {
        if (result)
          this.sub.reset(this.httpClient.delete(`/api/ControleFinancaXMovimentos/${this.controleFinancaXMovimento?.idControleFinancaXMovimento}`),
            () => this.isDeleted.emit(),
            () => this.snackBarService.exibirErro('Não foi possível excluir o registro!')
          );
        else
          this.unsubscribe();
      });
  }

  public verificaPago(blPago: boolean = true): boolean {
    return this.itensSelecionados.some(item => item.blPago == blPago);
  }

  public onCopiarCartao(): void {
    this.confirmService.confirm('Deseja copiar esse registro?', 'Alerta', 'Copiar')
      .subscribe(result => {
        if (result) {
          this.sub.reset(this.httpClient.post<BespCofxCopiarCartao>(`/api/ControleFinancaXMovimentos/CopiarCartao`, {
            idCofx: this.controleFinancaXMovimento?.idControleFinancaXMovimento
          }),
            (res) => {
              if (res.retorno) {
                this.snackBarService.exibirSucesso('Registro copiado com sucesso!');
              }
              else
                this.snackBarService.exibirErro(res.retornoMensagem!);
            },
            () => this.snackBarService.exibirErro('Não foi possível copiar o registro!')
          );
        }
        else
          this.unsubscribe();
      });

  }

  public onImportarCsv(): void {
    const dialogRef = this.dialog.open(DialogCsvConfigComponent, {
      width: '764px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((config: CsvConfig) => {
      if (config && config.arquivo) {
        this.processarArquivoCsv(config);
      }
    });
  }

  private processarArquivoCsv(config: CsvConfig): void {
    if (!config.arquivo) {
      this.snackBarService.exibirErro('Nenhum arquivo foi selecionado');
      return;
    }

    const reader = new FileReader();
    
    reader.onload = (e: any) => {
      const csvData = e.target.result;
      const linhas = csvData.split('\n');
      
      const linhasDados = linhas.slice(1);
      
      const movimentos: any[] = [];
      
      for (const linha of linhasDados) {
        if (!linha.trim()) continue;
        
        const colunas = linha.split(config.delimitador);
        
        const idxDescricao = config.colunaDescricao.charCodeAt(0) - 65;
        const idxValor = config.colunaValor.charCodeAt(0) - 65;
        const idxData = config.colunaData.charCodeAt(0) - 65;
        
        if (colunas.length > Math.max(idxDescricao, idxValor, idxData)) {
          const descricao = colunas[idxDescricao]?.trim() || '';
          const valorStr = colunas[idxValor]?.trim() || '0';
          const dataStr = colunas[idxData]?.trim() || '';
          
          let valor = 0;
          try {
            let valorLimpo = valorStr.replace('R$', '').trim();
            
            if (config.formatoValor.includes(',')) {
              valorLimpo = valorLimpo.replace(/\./g, '').replace(',', '.');
            }
            
            valor = parseFloat(valorLimpo) || 0;
          } catch (e) {
            console.error('Erro ao parsear valor:', valorStr, e);
          }
          
          let data = new Date();
          try {
            data = this.parseData(dataStr, config.formatoData);
          } catch (e) {
            console.error('Erro ao parsear data:', dataStr, e);
          }
          
          if (descricao) {
            movimentos.push({
              idControleFinancaMovimento: 0,
              noMovimentacao: descricao,
              vlMovimentacao: Math.abs(valor),
              dtMovimentacao: data,
              dtVencimento: data,
              blPago: false,
              blCopia: false,
              blSelecionado: true
            });
          }
        }
      }
      
      if (movimentos.length > 0) {
        this.abrirDialogImportacao(movimentos);
      } else {
        this.snackBarService.exibirErro('Nenhum dado válido foi encontrado no arquivo CSV');
      }
    };
    
    reader.onerror = () => {
      this.snackBarService.exibirErro('Erro ao ler o arquivo CSV');
    };
    
    reader.readAsText(config.arquivo);
  }

  private parseData(dataStr: string, formato: string): Date {
    const partes = dataStr.split(/[\/\-]/);
    
    switch (formato) {
      case 'DD/MM/AAAA':
        return new Date(parseInt(partes[2]), parseInt(partes[1]) - 1, parseInt(partes[0]));
      case 'DD/MM/AA':
        const ano = parseInt(partes[2]) + 2000;
        return new Date(ano, parseInt(partes[1]) - 1, parseInt(partes[0]));
      case 'AAAA-MM-DD':
        return new Date(parseInt(partes[0]), parseInt(partes[1]) - 1, parseInt(partes[2]));
      case 'MM/DD/AAAA':
        return new Date(parseInt(partes[2]), parseInt(partes[0]) - 1, parseInt(partes[1]));
      default:
        return new Date();
    }
  }

  private abrirDialogImportacao(movimentos: any[]): void {
    const dialogRef = this.dialog.open(DialogControleFinancaMovimentoComponent, {
      data: {
        title: 'Selecione os Movimentos para Importar',
        idCofx: this.controleFinancaXMovimento?.idControleFinancaXMovimento,
        noTipoMovimento: this.controleFinancaXMovimento?.noTipoMovimento,
        controleFinancaMovimentos: movimentos,
        buttonText: 'Importar',
        cancelButtonText: 'Cancelar',
      } as DialogControleFinancaMovimentoData,
    });

    dialogRef.afterClosed().subscribe((result: BeControleFinancaMovimento[]) => {
      if (result && result.length > 0) {
        this.importarMovimentos(result);
      }
    });
  }

  private importarMovimentos(movimentos: BeControleFinancaMovimento[]): void {
    const payload: BespCopiarListaMovimento = {
      listaCofm: movimentos.map(item => ({
        idCofm: 0,
        noMovimentacao: item.noMovimentacao!,
        vlMovimentacao: item.vlMovimentacao!
      }))
    };

    const movimentosParaSalvar = movimentos.map(m => ({
      idControleFinancaXMovimento: this.controleFinancaXMovimento?.idControleFinancaXMovimento,
      noMovimentacao: m.noMovimentacao,
      vlMovimentacao: m.vlMovimentacao,
      dtMovimentacao: m.dtMovimentacao,
      dtVencimento: m.dtVencimento,
      blPago: false,
      blGeradaCopia: false,
      blSelecionado: false
    }));

    let salvos = 0;
    let erros = 0;
    
    movimentosParaSalvar.forEach((movimento, index) => {
      this.httpClient.post<BeControleFinancaMovimento>('/api/ControleFinancaMovimentos/', movimento)
        .subscribe({
          next: () => {
            salvos++;
            if (salvos + erros === movimentosParaSalvar.length) {
              this.finalizarImportacao(salvos, erros);
            }
          },
          error: () => {
            erros++;
            if (salvos + erros === movimentosParaSalvar.length) {
              this.finalizarImportacao(salvos, erros);
            }
          }
        });
    });
  }

  private finalizarImportacao(salvos: number, erros: number): void {
    if (salvos > 0) {
      this.snackBarService.exibirSucesso(`${salvos} movimento(s) importado(s) com sucesso!`);
      this.ngOnInit();
      this.isChanged.emit();
    }
    if (erros > 0) {
      this.snackBarService.exibirErro(`${erros} movimento(s) não puderam ser importados`);
    }
  }

  public onAnexarImagem(controleFinancaMovimento: BeControleFinancaMovimento): void {
    this.dialog.open(DialogImagemComponent, {
      data: {
        title: 'Anexar Imagem',
        idControleFinancaMovimento: controleFinancaMovimento.idControleFinancaMovimento,
        isVisualizacao: false
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  public onVisualizarImagem(controleFinancaMovimento: BeControleFinancaMovimento): void {
    this.httpClient.get<{ imagemMinio: string, nomeArquivo: string }>
      (`/api/ControleFinancaMovimentos/ObterImagem/${controleFinancaMovimento.idControleFinancaMovimento}`)
      .subscribe({
        next: (response) => {
          this.dialog.open(DialogImagemComponent, {
            data: {
              title: 'Visualizar Imagem',
              idControleFinancaMovimento: controleFinancaMovimento.idControleFinancaMovimento,
              imagemMinio: response.imagemMinio,
              nomeArquivo: response.nomeArquivo,
              isVisualizacao: true
            }
          }).afterClosed().subscribe(result => {
            if (result === 'deleted') {
              controleFinancaMovimento.idImagem = null!;
              this.dataSrc._updateChangeSubscription();
            }
          });
        },
        error: (error) => {
          this.snackBarService.exibirErro('Erro ao carregar a imagem: ' + error.message);
        }
      });
  }

  public onDefinirCartao(idControleFinancaMovimento: number, idControleFinancaXMovimento: number): void {
    const movimento = this.dataSrc.data.find(x => x.idControleFinancaMovimento === idControleFinancaMovimento);
    if (!movimento) return;

    this.confirmService.confirm('Deseja mover este registro para outro cartão?', 'Mover', 'Mover')
      .subscribe(result => {
        if (result) {
          const data = { ...movimento };
          data.idControleFinancaXMovimento = idControleFinancaXMovimento;

          this.sub.reset(this.httpClient.put<BeControleFinancaMovimento>('/api/ControleFinancaMovimentos/', data),
            () => {
              this.snackBarService.exibirSucesso('Registro movido com sucesso!');
              this.dataSrc.data.splice(this.dataSrc.data.indexOf(movimento), 1);
              this.dataSrc._updateChangeSubscription();
              this.emitCount();
              this.isChanged.emit();
              this.isCartao.emit(data);
            },
            () => this.snackBarService.exibirErro('Não foi possível mover o registro!')
          );
        }
      });
  }

  private emitCount(): void {
    this.countChanged.emit(this.dataSrc.data.length);
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  private onResult(res: BeControleFinancaMovimento[]) {
    this.dataSrc.data = res;
    if (this.paginator) {
      this.dataSrc.paginator = this.paginator;
    }
    this.filterControl.setValue("");
    this.filterSubscription = this.filterControl.valueChanges.subscribe(v => {
      this.dataSrc.filterPredicate = (data: BeControleFinancaMovimento, filter: string) => {
        const controleFinancaMovimento = deburr(data.noMovimentacao ?? "").toLowerCase();
        const filtro = deburr(filter).toLowerCase();
        return controleFinancaMovimento.includes(filtro);
      };
      this.dataSrc.filter = v ?? "";
    });
  }

  private onDeleteConfirm(controleFinancaMovimento: BeControleFinancaMovimento) {
    this.dataSrc.data.splice(this.dataSrc.data.indexOf(controleFinancaMovimento), 1);
    this.dataSrc._updateChangeSubscription();
    this.emitCount();
    this.isChanged.emit();
    this.snackBarService.exibirSucesso('Registro excluído!');
    this.unsubscribe();
  }

  private getCallback(controleFinancaMovimento: BeControleFinancaMovimento, isPost = false, isPaid = false) {
    return {
      next: (res: BeControleFinancaMovimento) => {
        this.snackBarService.exibirSucesso(`Registro ${isPost ? 'criado' : 'alterado'}!`);
        this.editandoLinha = false;
        controleFinancaMovimento.editing = false;
        if (isPost) {
          controleFinancaMovimento.idControleFinancaMovimento = res.idControleFinancaMovimento;
        }
        if (isPaid) {
          controleFinancaMovimento.blPago = !controleFinancaMovimento.blPago;
        }
        this.isChanged.emit();
        this.unsubscribe();

        if (isPost) {
          setTimeout(() => {
            const button = document.getElementById(
              this.controleFinancaXMovimento?.noTipoMovimento!
            ) as HTMLButtonElement;
            if (button) {
              button.focus();
            }
          });
        }
      },
      error: (err: any) => {
        this.snackBarService.exibirErro(`${err.error} - Erro ${err.status} - ${err.statusText}`);
        this.onCancelarLinha(controleFinancaMovimento);
      }
    };
  }

  private cancelarLinha(controleFinancaMovimento: BeControleFinancaMovimento) {
    this.editandoLinha = false;
    if (controleFinancaMovimento.idControleFinancaMovimento) {
      controleFinancaMovimento.noMovimentacao = controleFinancaMovimento.originalValues!.noMovimentacao!;
      controleFinancaMovimento.vlMovimentacao = controleFinancaMovimento.originalValues!.vlMovimentacao!;
      controleFinancaMovimento.dtMovimentacao = controleFinancaMovimento.originalValues!.dtMovimentacao!;
      controleFinancaMovimento.dtVencimento = controleFinancaMovimento.originalValues!.dtVencimento!;
      controleFinancaMovimento.editing = false;
    }
    else {
      this.dataSrc.data.splice(this.dataSrc.data.indexOf(controleFinancaMovimento), 1);
      this.dataSrc._updateChangeSubscription();
      this.emitCount();
    }
    this.unsubscribe();
  }

  private clearSelectedItems(): void {
    this.dataSrc.data.forEach(item => item.blSelecionado = false);
    this.itensSelecionados = [];
    this.isChanged.emit();
    this.dataSrc._updateChangeSubscription();
  }
}
